"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _restArguments = _interopRequireDefault(require("./restArguments.js"));
var _flatten = _interopRequireDefault(require("./_flatten.js"));
var _bind = _interopRequireDefault(require("./bind.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Bind a number of an object's methods to that object. Remaining arguments
// are the method names to be bound. Useful for ensuring that all callbacks
// defined on an object belong to it.
var _default = exports.default = (0, _restArguments.default)(function (obj, keys) {
  keys = (0, _flatten.default)(keys, false, false);
  var index = keys.length;
  if (index < 1) throw new Error('bindAll must be passed function names');
  while (index--) {
    var key = keys[index];
    obj[key] = (0, _bind.default)(obj[key], obj);
  }
  return obj;
});